import { computed } from "vue";
export const programsRecord = (state) => {
  return computed(() => {
    return state
  })
}